import request from "../../../../helper/request";
export const validationApi = {
  update(params) {
    return request.post("/client/stop-validation", params);
  },
  getAll() {
    return request.get("/client/stop-validation").then((it) => [...it]);
  }
};
